import { Derivation } from '../interfaces/Derivation';
import { DerivationStatus } from '../enums/DerivationStatus';
// import { GenerateDerivationButton } from './GenerateCaseButton';
import { FinishDerivationButton } from './FinishDerivationButton';
import { AutoAssignDerivationButton } from './AutoAssignDerivationButton';

interface ButtonsProps {
  selectedDerivation: Derivation | null;
  handleDeselect: () => void;
  onTakeDerivation: () => void;
}

export const Buttons: React.FC<ButtonsProps> = ({
  selectedDerivation,
  onTakeDerivation,
  handleDeselect
}) => {
  return (
    <div className='flex flex-col gap-4'>
      {selectedDerivation?.status === DerivationStatus.PENDING && (
        <AutoAssignDerivationButton
          selectedDerivation={selectedDerivation}
          onTakeDerivation={onTakeDerivation}
        />
      )}
      {selectedDerivation?.status === DerivationStatus.ASSIGNED && (
        <div className='flex gap-4'>
          {/* <GenerateDerivationButton selectedDerivation={selectedDerivation} /> */}

          <FinishDerivationButton
            selectedDerivation={selectedDerivation}
            onDeselect={handleDeselect}
          />
        </div>
      )}
    </div>
  );
};
